// Shared Special PDF export definitions for the account-movement screens.
// Used by AllAccountMovements and AllPooledAccountMovement, which otherwise
// carried identical copies of all of this.

export const SPECIAL_PDF = "SpecialPDF";

export const SPECIAL_PDF_EXPORT_URL =
	"/bankapi/v1.0/Transaction/SearchAllAccountMovementsExportSpecialPDF";

export const SPECIAL_PDF_TITLE = "Account Summary Report";

export const SPECIAL_PDF_SINGLE_ACCOUNT_WARNING =
	"Special PDF supports only one account at a time. Please select a single account to continue.";

export const REPORT_TYPE_OPTIONS = [
	{ Value: "PDF", Text: "PDF" },
	{ Value: "CSV", Text: "CSV" },
	{ Value: "EXCEL", Text: "EXCEL" },
	{ Value: SPECIAL_PDF, Text: "Special PDF" }
];

// Special PDF renders a fixed layout, so the column set is not user editable.
const SPECIAL_PDF_COLUMNS = [
	{ columntype: "undefined", title: "DATE", type: "date", value: "TransactionDatePDF" },
	{ columntype: "undefined", title: "DESCRIPTION", type: "undefined", value: "DescriptionPDF" },
	{ columntype: "money", title: "WITHDRAWALS", type: "money", value: "Withdrawals" },
	{ columntype: "money", title: "DEPOSITS", type: "money", value: "Deposits" },
	{ columntype: "money", title: "BALANCE", type: "money", value: "RemainingBalancePDF" }
];

// Every grid column that may be exported: action and expander columns are
// excluded, as are columns explicitly hidden via show === false.
function columnsFromGrid(gridColumns) {
	const columns = [];
	gridColumns.forEach(c => {
		if (c.accessor !== "Actions" && c.accessor !== "ED" && (c.show === undefined || c.show === null || c.show)) {
			columns.push({ value: c.accessor, title: c.Header, columntype: c.ColumnType, type: c.type });
		}
	});
	return columns;
}

// Fresh objects each call: the result is held in component state and handed to
// the column picker, so callers must not share references.
export function exportColumnsFor(reportType, gridColumns) {
	return reportType === SPECIAL_PDF
		? SPECIAL_PDF_COLUMNS.map(c => ({ ...c }))
		: columnsFromGrid(gridColumns);
}
